import Actions from './action';

export const initState = {
	isAuthorisedLoading: false,
};

const companyInfoReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.SEND_EMAIL_START: {
			return {
				...state,
				isAuthorisedLoading: true,
			};
		}
		case Actions.types.SEND_EMAIL_SUCCESS: {
			return {
				...state,
				isAuthorisedLoading: false
			};
		}
		case Actions.types.SEND_EMAIL_ERROR: {
			return {
				...state,
				isAuthorisedLoading: false
			};
		}
		default:
			return state;
	}
};

export default companyInfoReducer;
